import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import { useEffect, useState, useContext } from "react";
import configuration from "../../Utility/config.json";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import { Link } from "react-router-dom";
import LabelsLoader  from "../../Utility/labelsLoader";

function HomeUser(props) {
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState({});
  const [isOpen, toggleModal] = useState(false);
  const apiToken = useContext(TokenContext);
  const auth_url = process.env.REACT_APP_AUTH_URL;
  const entity_url = process.env.REACT_APP_ENTITY_URL;

  const [announcementsBacheca, setAnnouncementsBacheca] = useState();

  const queryParameters =
    "?returnUrl=" +
    window.location.protocol +
    "//" +
    window.location.host +
    props.subfolder +
    entity_url;
    const labels = LabelsLoader();
  useEffect(() => {
    // 👇️ set isMounted to true
    let isMounted = true;

    async function fetchData() {
      const result = await Promise.resolve(["Unmounted Component"]);

      // 👇️ only update state if component is mounted
      if (isMounted) {
        setLoading(false);

        Repo.getAnnouncementsBacheca(apiToken)
          .then((response) => {
            setAnnouncementsBacheca(response.data);
            setLoading(true);
          })
          .catch((error) => {
            console.log(error);
          });

        Repo.getUserServices(apiToken)
          .then((response) => {
            setServices(response.data);
            setLoading(true);
          })
          .catch((error) => {
            console.log(error);
            setLoading(true);
          });
      }
    }

    fetchData();

    return () => {
      // 👇️ when component unmounts, set isMounted to false
      isMounted = false;
    };
  }, []);

  const loginRedirect = () => {
    window.location.href =
      auth_url + configuration.AUTH_PATH_LOGIN + queryParameters;
  };

  return (
    <>
      <div className="alert alert-info" role="alert">
        <h4 className="alert-heading">{labels.attenzione}</h4>
        <div className="row">
          <div className="col-lg-10">
            <p>
            {labels.aiuto}
            </p>
          </div>
          <div className="col-lg-2 text-right">
            <a
              type="button"
              href={auth_url + configuration.AUTH_PATH_LOGIN + queryParameters}
              className="btn btn-outline-primary btn-sm"
            >
              <span>Accedi</span>
            </a>
          </div>
        </div>
      </div>

      {announcementsBacheca && announcementsBacheca.length > 0 && (
        <div className="row mt-4 mb-4">
          <div className="col-lg-12">
            <h3 className="pl-2 mb-3">Bacheca</h3>
            <p className="pl-2">{labels.bandi_aperti}</p>
            <div className="row">
              {announcementsBacheca &&
                announcementsBacheca.length > 0 &&
                announcementsBacheca.slice(0, 3).map((x, index) => (
                  <div key={x.id} className="col-12 col-lg-4">
                    <Link
                      to={"/sessione_servizi/visualizza_servizio?id=" + x.id}
                      className="text-decoration-none"
                    >
                      <div className="card-wrapper card-space cardCustom">
                        <div className="card card-bg no-after roundedCustomBandi p-2">
                          <div className="card-body">
                            <h5
                              style={{ fontSize: "23px" }}
                              className="card-title"
                            >
                              {x.name && x.name}
                            </h5>

                            <p
                              style={{ fontSize: "20px" }}
                              className="card-text mb-0"
                            >
                              Data inserimento:{" "}
                              <strong>{x.dataInsert && x.dataInsert}</strong>
                            </p>

                            <div className="row">
                              <div className="col-12 mt-4 text-right">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-sm"
                                >
                                  <span>Dettaglio</span>
                                  <span>
                                    <svg className="icon icon-primary icon-sm">
                                      <use
                                        href={`${iconSprite}#it-arrow-right`}
                                      />
                                    </svg>
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-lg-12">
          <h2 className="pl-2 mb-3">Servizi</h2>
          <div className="row">
            {services &&
              services.length > 0 &&
              services.map((x, index) => (
                <div key={x.id} className="col-12 col-lg-12">
                  <div className="card-wrapper card-space cardCustom">
                    <div className="card card-bg no-after roundedCustom p-2 ">
                      <div className="card-body">
                        <h5 style={{ fontSize: "23px" }} className="card-title">
                          {x.name}
                        </h5>
                        <div className="row">
                          <div className="col-12">
                            <p
                              style={{ fontSize: "20px" }}
                              className="card-text"
                            >
                              {x.description}
                            </p>
                          </div>
                          <div className="col-12 mt-4 text-right">
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={() => toggleModal(!isOpen)}
                            >
                              <span> Richiedi Servizio</span>
                              <span>
                                <svg className="icon icon-primary icon-sm">
                                  <use href={`${iconSprite}#it-arrow-right`} />
                                </svg>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Attenzione!"
        body="Per poterti iscrivere ai servizi devi effettuare il login con SPID o CIE."
        buttonConfirm="Login"
        buttonDeny="Annulla"
        function={() => loginRedirect()}
      ></ModalComponent>

      {!loading && <Loader></Loader>}
    </>
  );
}

export default HomeUser;
